import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, lazy, Suspense } from 'react';
import Avatar from '@classify/react-core-components/Avatar';
import Box from '@classify/react-core-components/Box';
import { translate } from '@openclassrooms/translations';
import { helpSession } from '@openclassrooms/common-app/contact/services';
import { clientApi } from '@openclassrooms/data-connect-web/configuration';
import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';
import LoadingState from './LoadingState';
const PROMPT_NAME = 'enrollment-support';
interface Props {
  data: {
    initialMessage?: string;
  };
}
const AsyncChatbot = lazy(() => import('@classify/react-product-components/Chatbot'));
export default function PageCompanion(t0) {
  const $ = _c(38);
  const {
    data
  } = t0;
  const [isPushingContext, setIsPushingContext] = useState(true);
  const [currentThread, setCurrentThread] = useState();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clientApi.getAIClient("ai-api-user");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const sdk = t1;
  const {
    currentUser,
    isPending: isUserLoading
  } = useCurrentUserContext();
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const triggerPageContentGathering = async () => {
        helpSession.updateCurrentPageContent();
        const existingThreadId = await helpSession.getThreadId();
        if (existingThreadId) {
          setCurrentThread(existingThreadId);
        }
        try {
          await sdk.prompt(PROMPT_NAME, {
            input: [{
              content: helpSession.getCurrentTopicAsPromptString(),
              role: "hidden",
              rule: {
                include_if: `context.sessionId == ${helpSession.getCurrentId()}`
              }
            }],
            threadId: existingThreadId,
            onThreadCreated: thread => {
              setCurrentThread(thread);
              helpSession.setThreadId(thread);
            }
          });
        } catch {}
        setIsPushingContext(false);
      };
      triggerPageContentGathering();
    };
    t3 = [sdk];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  if (isUserLoading || isPushingContext || !currentThread) {
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <LoadingState />;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LoadingState />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = data?.initialMessage;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      name: PROMPT_NAME
    };
    t7 = translate("iabot.conversation.placeholder");
    t8 = translate("iabot.thread.default.label");
    t9 = translate("iabot.name");
    t10 = translate("iabot.more.startconversation.label");
    t11 = translate("iabot.error.tokenslimits.label");
    t12 = translate("iabot.enrollment.answer.placeholder.label");
    t13 = translate("iabot.error.global.label");
    t14 = translate("iabot.fullscreen.exit");
    t15 = translate("iabot.fullscreen.open.label");
    t16 = translate("iabot.more.startconversation.label");
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t14;
    $[10] = t15;
    $[11] = t16;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t13 = $[8];
    t14 = $[9];
    t15 = $[10];
    t16 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  const t17 = currentUser?.displayName;
  let t18;
  let t19;
  let t20;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = translate("iabot.homepage.label");
    t19 = {
      thankYou: translate("Companioniabot.project.feedback_question.snackbar.success"),
      like: translate("iabot.feedback.useful"),
      dislike: translate("iabot.feedback.unuseful")
    };
    t20 = translate("iabot.disclaimer.mistakes");
    $[16] = t18;
    $[17] = t19;
    $[18] = t20;
  } else {
    t18 = $[16];
    t19 = $[17];
    t20 = $[18];
  }
  let t21;
  if ($[19] !== t17) {
    t21 = {
      placeholder: t7,
      defaultThreadTitle: t8,
      botName: t9,
      newChat: t10,
      tokensLimitsLabel: t11,
      initPrompt: t12,
      errorGlobalLabel: t13,
      exitFullScreen: t14,
      openFullScreen: t15,
      startNewThread: t16,
      userName: t17,
      goToHomepage: t18,
      messageFeedback: t19,
      warningMessage: t20
    };
    $[19] = t17;
    $[20] = t21;
  } else {
    t21 = $[20];
  }
  const t22 = currentUser?.displayName ?? "";
  const t23 = currentUser?.id ?? 0;
  const t24 = currentUser?.profilePicture;
  let t25;
  if ($[21] !== t22 || $[22] !== t23 || $[23] !== t24) {
    t25 = <Avatar size="xs" userName={t22} userId={t23} src={t24} />;
    $[21] = t22;
    $[22] = t23;
    $[23] = t24;
    $[24] = t25;
  } else {
    t25 = $[24];
  }
  let t26;
  if ($[25] !== currentThread) {
    t26 = async (promptName, params) => sdk.prompt(promptName, {
      ...params,
      context: {
        sessionId: helpSession.getCurrentId()
      },
      threadId: currentThread
    });
    $[25] = currentThread;
    $[26] = t26;
  } else {
    t26 = $[26];
  }
  let t27;
  let t28;
  let t29;
  let t30;
  let t31;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = threadId => {
      setCurrentThread(threadId);
    };
    t28 = async threadId_0 => sdk.getThread(threadId_0);
    t29 = async threadId_1 => sdk.getThreadMessages(threadId_1);
    t30 = async (messageId, isLiked) => sdk.rateMessage(messageId, isLiked);
    t31 = async (threadId_2, title) => sdk.setThreadTitle(threadId_2, title);
    $[27] = t27;
    $[28] = t28;
    $[29] = t29;
    $[30] = t30;
    $[31] = t31;
  } else {
    t27 = $[27];
    t28 = $[28];
    t29 = $[29];
    t30 = $[30];
    t31 = $[31];
  }
  let t32;
  if ($[32] !== currentThread || $[33] !== t21 || $[34] !== t25 || $[35] !== t26 || $[36] !== t5) {
    t32 = <Suspense fallback={t4}><Box sx={_temp}><AsyncChatbot isToolbarHidden={true} initialMessage={t5} prompt={t6} translations={t21} threadId={currentThread} userAvatar={t25} displayMode="fullScreenWithoutHistory" onPrompt={t26} onThreadSelected={t27} onGetThread={t28} onGetThreadMessages={t29} onRateMessage={t30} onSetThreadTitle={t31} isBeta={true} /></Box></Suspense>;
    $[32] = currentThread;
    $[33] = t21;
    $[34] = t25;
    $[35] = t26;
    $[36] = t5;
    $[37] = t32;
  } else {
    t32 = $[37];
  }
  return t32;
}
function _temp(theme) {
  return {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    "--ai-chatbot-message-bgcolor": "transparent",
    "--ai-chatbot-avatar-bgcolor": theme.palette.background.paper
  };
}